import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../app/store'
import BasicModalWindow from '../../components/BasicModalWIndow'
import { useDispatch } from 'react-redux'
import { updateInventoryItemListRefresh, updateNewStockDetails, updateNewStockModalStatus } from './itemsSlice'
import { TextField } from '@mui/material'
import { updateTransactionTriggerTranscationsRefresh } from '../transactions/transactionsSlice'
import ItemsApp from './ItemsApp'
import { handleRequestError } from '../../services/api'
import QuantitySlider from '../transactions/QuantitySlider'

export default function NewStock() {

    const dispatch = useDispatch()

    const { newStockDetails, newStockOpen, reduceStock } = useSelector((state: RootState) => state.items)

    const [loading, setLoading] = useState<boolean>(false)

    const itemsApp = new ItemsApp()

    /**
     * Handle close modal
     */
    const handleCloseModal = () => {
        if (!loading){
            dispatch(updateNewStockModalStatus(false))
            dispatch(updateNewStockDetails({
                item_id: 0,
                warehouse_id: null,
                section_id: null,
                location_id: null,
                user_id: null,
                quantity: 1,
                timestamp: "",
                note: "",
                available_quantity: 0
            }))
        }
    }

    /**
     * Refresh Transcations
     */
    const handleRefreshTranscations = () => dispatch(updateTransactionTriggerTranscationsRefresh(true))

    /**
     * Refresh Inventory
     */
    const handleRefreshInventory = () => dispatch(updateInventoryItemListRefresh(true))

    /**
     * Handle submit
     */

    const resetModal = () => {
        handleRefreshTranscations()
        handleRefreshInventory()

        handleCloseModal()
        setLoading(false)
    }

    const handleNewStock = () => {
        setLoading(true)

        itemsApp.addNewStockItem(
            newStockDetails.item_id,
            newStockDetails.warehouse_id,
            newStockDetails.section_id,
            newStockDetails.location_id,
            newStockDetails.user_id,
            newStockDetails.quantity,
            newStockDetails.timestamp,
            newStockDetails.note
        )
            .then(response => {
                resetModal()
            })
            .catch(error => {
                setLoading(false)
                handleRequestError(error, dispatch)
            })
    }

    const handleReuceStock = () => {
        setLoading(true)

        itemsApp.reduceStock(            
            newStockDetails.item_id,
            newStockDetails.warehouse_id,
            newStockDetails.section_id,
            newStockDetails.location_id,
            newStockDetails.user_id,
            newStockDetails.quantity,
            newStockDetails.timestamp,
            newStockDetails.note
        )
            .then(response => {
                resetModal()
            })
            .catch(error => {
                setLoading(false)
                handleRequestError(error, dispatch)
            })
    }

    return(
        <BasicModalWindow
            shown={newStockOpen}
            size="sm"
            handleClose={handleCloseModal}
            actionButtons={[
                {
                    label: !reduceStock ? "Add" : "Reduce Stock",
                    color: "success",
                    onClick: () => reduceStock ? handleReuceStock() : handleNewStock(),
                    disabled: loading
                },
                {
                    label: "Cancel",
                    color: "error",
                    onClick: () => handleCloseModal(),
                    disabled: loading
                }
            ]}
            title={reduceStock ? "Reduce Stock" : "New Stock"}
            showHeader
            actionButtonsBottom
        >

            {!reduceStock ? (
                <TextField type="number" variant="outlined" fullWidth label="Quantity" value={newStockDetails.quantity} onChange={(e) => dispatch(updateNewStockDetails({
                    ...newStockDetails,
                    quantity: Number(e.target.value)
                }))} inputProps={{ min: 1 }} />
            ) : (
                <QuantitySlider itemMaxAvailableQnt={newStockDetails.available_quantity - 1} quantity={newStockDetails.quantity} updateQuantity={(qnt) => dispatch(updateNewStockDetails({
                    ...newStockDetails,
                    quantity: qnt
                }))} />
            )}

            <TextField type="text" multiline maxRows={6} minRows={4} value={newStockDetails.note} onChange={(e) => dispatch(updateNewStockDetails({
                ...newStockDetails,
                note: e.target.value
            }))} fullWidth label="Note" style={{ marginTop: 10 }} />


        </BasicModalWindow>
    )
}